let org = {
    note: "Note: Operate the organizational structure through the right-click menu",
    organization: "Organization",
    orgDetail: "Details",
    updateOrg: "Edit",
    addOrg: "Add",
    deleteOrg: "Delete",
    orgNumber: "Org Number",
    orgName: "Org Name",
    enterOrgName: "Please enter organization name",
    orgParent: "Parent Org",
    orgParentName: "Parent Org",
    confirmDeleteOrg: "Delete this organization {name} and its sub-organization?)",
    selOrganization: "Please select an organization",

}

export default org
